import { Component } from '@ecs/Component';

export class TargetHighlight implements Component {
  readonly type = 'TargetHighlight';
  
  constructor(
    public isTargeted: boolean = false,
    public highlightColor: string = '#00ff88',
    public highlightRadius: number = 10
  ) {}
}